import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import React from 'react'

const SureModal = ({ visible, setVisible, onClickYes, subscribeModal = false }) => {
    return (
        <>
            <CModal
                alignment="center"
                visible={visible}
                onClose={() => setVisible(false)}
                size='sm'
                aria-labelledby="VerticallyCenteredExample"
                keyboard={true}
            >
                <CModalHeader>
                    {
                      !subscribeModal ?
                      <CModalTitle id="VerticallyCenteredExample">Удалить?</CModalTitle>
                      :
                      <CModalTitle id="VerticallyCenteredExample">Отменить подписку?</CModalTitle>
                    }
                </CModalHeader>
                <CModalFooter style={{ display: 'flex', justifyContent: 'space-evenly', borderTop: 'unset' }} >
                    <CButton onClick={onClickYes} style={{ color: '#fff', padding : '3px 50px' }} color="primary">
                        Да
                    </CButton>
                    <CButton style={{ color: '#fff', padding : '3px 50px' }} color="secondary" onClick={() => setVisible(false)}>
                        Нет
                    </CButton>
                </CModalFooter>
            </CModal>
        </>
    )
}

export default SureModal